import React, { Component } from 'react'
import Header from "../IssuePages/Header/Header";
import "./../../Styles/Awards/AwardDetails.css";
import "bootstrap/dist/css/bootstrap.min.css";
import MobHeader from "../IssuePages/Header/Mob_Header";
import axios from "axios";
import Collapsible from "react-collapsible";
import {
  get_mission_by_slug,
  // paid_remaining_subs,
  // payment_mode_missions,
  // get_submissions,
  // is_like,
  // get_finalist,
  // get_winners,
  // get_inspirations,
  // get_mostVotedSubmissions,
  // get_SectionList_byTopic,
  get_faq_section
} from "../common/AppConstants";
import ReactHtmlParser from "react-html-parser";
// import MenuItem from "@material-ui/core/MenuItem";
// import Menu from "@material-ui/core/Menu";
// import Img from "react-image";
// import PostViewerDial from "../User/PostViewer/PostViewerDial";
// import frenchStrings from "react-timeago/lib/language-strings/en";
// import buildFormatter from "react-timeago/lib/formatters/buildFormatter";
// import firebase from "../Login/firebaseConfig";
import Iframe from "react-iframe";
// import cogoToast from "cogo-toast";
// import { ThemeProvider } from "@material-ui/styles";
// import ReactGA from "react-ga";
// import StackGrid from "react-stack-grid";
import MissionTime from "./MissionTime";


var sections = [];

var mission_data = []

export default class MissionPageMob extends Component {

  constructor(props){
    super(props)

    
    this.state = {
      slug : props.match.params.slug
    }
  }

    componentDidMount =()=>{
        axios
        .get(get_mission_by_slug + this.state.slug)
        .then(res => {
          mission_data = res.data;
          //console.log(res.data)

          this.getSectionList(res.data.faqSectionId);
          this.forceUpdate()
        })
        .catch(error => {
          if (error.message.status) {
            if (error.response.status === 404) {
              this.props.history.replace("/page-not-found");
            }
          }
        });
    }
    

      // get section list
  getSectionList = id => {
    axios.get(get_faq_section + id).then(res => {
      sections = res.data;
      //console.log(sections);
      this.forceUpdate();
    });
  };
    
    render() {
        return (
                 <>
        {window.innerWidth < 768 ? (
          <div>
          {mission_data ? 
          <div style={{ background: "white" }}>

            <MobHeader
              url={mission_data.coverUrl}
              heading={mission_data.hashTag}
              sub_heading={mission_data.title}
              login = 'false'
            />
            


{/* ======= */}


<div style={{ position: "relative" }}>
                  {/* ------------------------------ */}
                  <div
                    className="row"
                    style={{
                      justifyContent: "center",
                      marginTop: "51px",
                      border: "1px solid #b8a33b",
                      padding: "15px",
                      marginLeft: "10px",
                      marginRight: "10px"
                    }}
                  >
                    <div>
                      <p className="about_">
                        {ReactHtmlParser(mission_data.prizeText)}
                      </p>
                    </div>
                  </div>
                  {/* ------------------------------ */}

                  <div
                    className="row"
                    style={{ justifyContent: "center", marginTop: "21px" }}
                  >
                    <p className="about_" style={{ padding: "20px" }}>
                      {ReactHtmlParser(mission_data.aboutHtml)}
                    </p>
                  </div>

                  {/* ------------------------------ */}

                  <div>
                    {mission_data.timelines ? (
                      mission_data.timelines[0].title === "" ? (
                        ""
                      ) : (
                        <MissionTime data={mission_data} />
                      )
                    ) : (
                      ""
                    )}{" "}
                  </div>
                  {/* ------------------------------ */}

                  {mission_data.coverMovie === "" ? (
                    <></>
                  ) : (
                    <div
                      className="row"
                      style={{ justifyContent: "center", marginTop: "32px" }}
                    >
                      <div style={{ height: "200", width: "300px" }}>
                        <Iframe
                          width="300px"
                          height="200px"
                          id="myId"
                          className="myClassname"
                          src={mission_data.coverMovie}
                          // allow="fullscreen"
                          position="relative"
                        />
                      </div>
                    </div>
                  )}

                  {/* ------------------------------ */}

                  {/* ------------------------------ */}

                  {/* --------------------------- */}

                  <div
                    className="row"
                    style={{ marginTop: "40px", justifyContent: "center" }}
                  >
                    {mission_data.sponsors ? (
                      mission_data.sponsors.map((value, i) => {
                        if (
                          value.name === "Add Sponsor 1" ||
                          value.name === "Add Sponsor 2" ||
                                value.name === "Add Sponsor 3" ||
                                value.name === "Add Sponsor 4" ||
                                value.name === "Add Sponsor 5" ||
                                value.name === "Add Sponsor 6" ||
                                value.name === "Add Sponsor 7" ||
                                value.name === "Add Sponsor 8" ||
                                value.name === "Add Sponsor 9" ||
                                value.name === "Add Sponsor 10" 
                        ) {
                          return ''
                        } else {
                          return (
                            <>
                              {i === 0 ? (
                                <div
                                  className="row col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                                  style={{
                                    justifyContent: "center",
                                    marginTop: "110px"
                                  }}
                                >
                                  <p className="Candid2019">#Partners</p>
                                </div>
                              ) : (
                                <></>
                              )}

                              <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 mt-4">
                                <a
                                  style={{
                                    textDecoration: "none",
                                    color: "black"
                                  }}
                                  rel="noopener noreferrer"
                                  target="_blank"
                                  href={value.website}
                                >
                                  <img
                                    alt="jury_image"
                                    className="juPh"
                                    id="ju_image_category"
                                    src={value.logo}
                                  />
                                  <p className="ju_name">{value.name}</p>
                                  <p className="ju_desc">{value.type}</p>
                                </a>
                              </div>
                            </>
                          );
                        }
                      })
                    ) : (
                      <></>
                    )}
                  </div>

                  <div
                    className="row"
                    style={{ marginTop: "40px", justifyContent: "center" }}
                  >
                    {mission_data.juries ? (
                      mission_data.juries.map((value, i) => {
                        if (value.userSlug === "") {
                          return ''
                        } else {
                          return (
                            <>
                              {/* --------------------------------- */}

                              {i === 0 ? (
                                <div
                                  className="row col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                                  style={{
                                    justifyContent: "center",
                                    marginTop: "110px"
                                  }}
                                >
                                  <p className="Candid2019">#Juries</p>
                                </div>
                              ) : (
                                <></>
                              )}
                              {/* ------------------------------ */}
                              <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 mt-4">
                                <a
                                  href={value.redirectLink}
                                  style={{
                                    textDecoration: "none",
                                    color: "black"
                                  }}
                                  rel="noopener noreferrer"
                                  target="_blank"
                                >
                                  <img
                                    className="juPh"
                                    id="ju_image_category"
                                    src={value.user.photoUrl}
                                    alt="#juriesFashiongraphy1"
                                  />
                                </a>

                                <a
                                  href={value.redirectLink}
                                  style={{
                                    textDecoration: "none",
                                    color: "black"
                                  }}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <p className="ju_name">
                                    {value.user.displayName}
                                  </p>
                                </a>

                                <a
                                  href={value.redirectLink}
                                  style={{
                                    textDecoration: "none",
                                    color: "black"
                                  }}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <p className="ju_desc">{value.bio}</p>
                                </a>
                              </div>

                              {/* </div> */}
                            </>
                          );
                        }
                      })
                    ) : (
                      <></>
                    )}
                  </div>

                  {/* ================================ */}

               

                  <div className="container" style={{ marginTop: "60px" }}>
                    {sections.questions ? (
                      sections.questions.map((value, index) => {
                        return (
                          <div class style={{ textAlign: "start" }}>
                            <Collapsible
                              trigger={
                                <div className='row question mt-2'>
                                  <div className='col-10 col-sm-10 col-md-10'>
                                <p>{value.questionText}</p>
                                </div>
                                <div className='col-2 col-2 col-md-2'>
                                <img 
                                  src={require('../../logo/down.svg')} 
                                  alt='Down'
                                  style={{height:'20px', width:'20px', opacity:'.7'}} 
                                  />  
                                </div>
                                
                              </div>
                              }
                            >
                              <p className="answer">
                                {ReactHtmlParser(value.answerHtml)}
                              </p>
                            </Collapsible>
                          </div>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </div>

                  <div style={{ marginTop: "80px", marginBottom:'60px' }}>
                    <img src={require("../../logo/chat.svg")} alt="chat_logo" />
                    <p className="about_" style={{ marginTop: "20px" }}>
                      {" "}
                      Question or problem?
                    </p>
                    <p className="about__">
                      {" "}
                      Contact our team:<b> team@wallmag.io</b>
                    </p>
                    <p className="about__"> and we’ll reply within 24 hours.</p>
                  </div>
                </div>
          


{/* ===== */}

            </div>
        :''
                    }
                    </div>)
        :
            <>
            {mission_data ? 
       
            <div style={{ background: "white" }}>
              <Header
                url={mission_data.coverUrl}
                heading={mission_data.hashTag}
                sub_heading={mission_data.title}
                login = 'false'
              />

<div
                      className="container-fluid"
                      style={{ position: "relative" }}
                    >
                      <div className="container">
                        {/* ------------------------------ */}
                        <div
                          className="row"
                          style={{
                            justifyContent: "center",
                            marginTop: "51px",
                            border: "1px solid #b8a33b",
                            padding: "45px"
                          }}
                        >
                          <div style={{ marginLeft: "40px" }}>
                            <p className="about_">
                              {ReactHtmlParser(mission_data.prizeText)}
                            </p>
                          </div>
                        </div>
                        {/* ------------------------------ */}

                        <div
                          className="row"
                          style={{
                            justifyContent: "center",
                            marginTop: "101px"
                          }}
                        >
                          <p className="about_">
                            {ReactHtmlParser(mission_data.aboutHtml)}
                          </p>
                        </div>

                        {/* ------------------ */}

                        <div
                          className="row"
                          style={{
                            justifyContent: "center",
                            marginTop: "80px"
                          }}
                        >
                          <div>
                            {mission_data.timelines ? (
                              mission_data.timelines[0].title === "" ? (
                                ""
                              ) : (
                                <MissionTime data={mission_data} />
                              )
                            ) : (
                              ""
                            )}
                          </div>
                        </div>

                        {mission_data.coverMovie === "" ? (
                          <></>
                        ) : (
                          <div
                            className="row"
                            style={{
                              justifyContent: "center",
                              marginTop: "51px"
                            }}
                          >
                            <Iframe
                              width="600px"
                              height="350px"
                              id="myId"
                              className="myClassname"
                              src={mission_data.coverMovie}
                              allow="fullscreen"
                              position="relative"
                            />
                          </div>
                        )}

                        {/* ---------------------------- */}

                        {/* ------------------------------ */}

                        {/* <div
                          className="row"
                          style={{
                            justifyContent: "center",
                            marginTop: "20px"
                          }}
                        >
                          <div>
                            <img
                              src={require("../../logo/junk.svg")}
                              alt="award-icon"
                              style={{ padding: "5px" }}
                            />
                          </div>

                          <div>
                            <p className="small_desc">
                              <b>{mission_data.info}</b>
                            </p>
                          </div>
                        </div>
                         */}

                        {/* ------------------------------ */}

                        {/*-------------------        */}

                        <div
                          className="row"
                          style={{
                            marginTop: "40px",
                            justifyContent: "center"
                          }}
                        >
                          {mission_data.sponsors ? (
                            mission_data.sponsors.map((value, i) => {
                              return value.name === "Add Sponsor 1" ||
                                value.name === "Add Sponsor 2" ||
                                value.name === "Add Sponsor 3" ||
                                value.name === "Add Sponsor 4" ||
                                value.name === "Add Sponsor 5" ||
                                value.name === "Add Sponsor 6" ||
                                value.name === "Add Sponsor 7" ||
                                value.name === "Add Sponsor 8" ||
                                value.name === "Add Sponsor 9" ||
                                value.name === "Add Sponsor 10" ?  (
                                <></>
                              ) : (
                                <>
                                  {i === 0 ? (
                                    <div
                                      className="row col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                                      style={{
                                        justifyContent: "center",
                                        marginTop: "110px"
                                      }}
                                    >
                                      <p className="Candid2019">#Partners</p>
                                    </div>
                                  ) : (
                                    <></>
                                  )}

                                  <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 mt-4">
                                    <a
                                      style={{
                                        textDecoration: "none",
                                        color: "black"
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={value.website}
                                    >
                                      <img
                                        alt="juries"
                                        className="juPh"
                                        id="ju_image_category"
                                        src={value.logo}
                                      />
                                      <p className="ju_name">{value.name}</p>
                                      <p className="ju_desc">{value.type}</p>
                                    </a>
                                  </div>
                                </>
                              );
                            })
                          ) : (
                            <></>
                          )}
                        </div>

                        <div
                          className="row"
                          style={{
                            marginTop: "40px",
                            justifyContent: "center"
                          }}
                        >
                          {mission_data.juries ? (
                            mission_data.juries.map((value, i) => {
                              if (value.userSlug === "") {
                                return ''
                              }
                               else {
                                return (
                                  <>
                                    {/* --------------------------------- */}

                                    {i === 0 ? (
                                      <div
                                        className="row col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                                        style={{
                                          justifyContent: "center",
                                          marginTop: "110px"
                                        }}
                                      >
                                        <p className="Candid2019">#Juries</p>
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                    {/* ------------------------------ */}
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 mt-4">
                                      <a
                                        href={value.redirectLink}
                                        style={{
                                          textDecoration: "none",
                                          color: "black"
                                        }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <img
                                          className="juPh"
                                          alt='Juries'
                                          id="ju_image_category"
                                          src={value.user.photoUrl}
                                          alt="#juriesFashiongraphy"
                                        />
                                      </a>

                                      <a
                                        href={value.redirectLink}
                                        style={{
                                          textDecoration: "none",
                                          color: "black"
                                        }}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                      >
                                        <p className="ju_name">
                                          {value.user.displayName}
                                        </p>
                                      </a>

                                      <a
                                        href={value.redirectLink}
                                        style={{
                                          textDecoration: "none",
                                          color: "black"
                                        }}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                      >
                                        <p className="ju_desc">{value.bio}</p>
                                      </a>
                                    </div>
                                  </>
                                );
                              }
                            })
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>

                     {/* ==================================== */}

                      <div className="container" style={{ marginTop: "60px" }}>
                        {sections.questions ? (
                          sections.questions.map((value, index) => {
                            return (
                              <div class style={{ textAlign: "start" }}>
                                <Collapsible
                                  trigger={
                                    <div className='row question mt-2'>
                                  <div className='col-10 col-sm-10 col-md-10'>
                                <p>{value.questionText}</p>
                                </div>
                                <div className='col-2 col-2 col-md-2'>
                                <img 
                                  src={require('../../logo/down.svg')} 
                                  alt='Down Arrow'
                                  style={{height:'20px', width:'20px', opacity:'.7',position:'absolute', right:'20px'}} 
                                  />  
                                </div>
                                
                              </div>
                                  }
                                >
                                  <p className="answer">
                                    {ReactHtmlParser(value.answerHtml)}
                                  </p>
                                </Collapsible>
                              </div>
                            );
                          })
                        ) : (
                          <></>
                        )}
                      </div>

                      <div style={{ marginTop: "140px", paddingBottom:'100px'  }}>
                        <img
                          src={require("../../logo/chat.svg")}
                          alt="chat_logo"
                        />
                        <p className="about__" style={{ marginTop: "20px" }}>
                          {" "}
                          Question or problem?
                        </p>

                        <p className="about__">
                          {" "}
                          Contact our team:<b> team@wallmag.io</b>
                        </p>
                        <p className="about__" style={{}}>
                          {" "}
                          and we’ll reply within 24 hours.
                        </p>
                      </div>

                    

                     </div>
              

            </div>
            :'hi'
    }
            </>
        
    }
    </>

        )
    }
}
